import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import {
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Theme,
} from '@mui/material';

import { ContactProps } from '@/models/Contact';

type Props = {
  theme: Theme;
  value: number | null;
  options: ContactProps[];
  loading: boolean;
  disabled: boolean;
  onChange: (contactId: number, contact?: ContactProps) => void;
};

export function PrimaryContactSelect({
  theme,
  value,
  options,
  loading,
  disabled,
  onChange,
}: Props) {
  const selectedValue =
    value != null && options.findIndex((c) => c.id === value) !== -1 ? value.toString() : '';

  return (
    <FormControl fullWidth>
      <InputLabel id='primary-contact-label'>Primary Contact</InputLabel>

      <Select
        labelId='primary-contact-label'
        label='Primary Contact'
        MenuProps={{ PaperProps: { sx: { maxHeight: 300, maxWidth: 460 } } }}
        value={selectedValue}
        disabled={disabled}
        IconComponent={(_props) => {
          const iconClassName = String((_props as { className?: string }).className ?? '');

          if (loading) {
            return (
              <CircularProgress
                size={'20px'}
                style={{
                  right: '10px',
                  position: 'absolute',
                  top: 'calc(50 % - 0.5em)',
                  color: 'rgb(0, 0, 0, 0.54)',
                  pointerEvents: 'none',
                }}
              />
            );
          }

          if (iconClassName.includes('MuiSelect-iconOpen')) {
            return (
              <ArrowDropUpIcon
                style={{
                  right: '7px',
                  position: 'absolute',
                  top: 'calc(50 % - 0.5em)',
                  color: 'rgb(0, 0, 0, 0.54)',
                  pointerEvents: 'none',
                }}
              />
            );
          }

          return (
            <ArrowDropDownIcon
              style={{
                right: '7px',
                position: 'absolute',
                top: 'calc(50 % - 0.5em)',
                color: 'rgb(0, 0, 0, 0.54)',
                pointerEvents: 'none',
              }}
            />
          );
        }}
        renderValue={(raw: string) => {
          if (loading) {
            return <span style={{ color: theme.palette.text.secondary }}>Loading ...</span>;
          }

          const selectedId = Number(raw);
          const c = options.find((o) => o.id != null && o.id === selectedId);
          return c != null ? `${c.firstName} ${c.lastName} (${c.email})` : '';
        }}
        onChange={(e: SelectChangeEvent) => {
          const id = Number(e.target.value);
          const contact = options.find((c) => c.id === id);
          if (!Number.isNaN(id)) onChange(id, contact);
        }}
      >
        {options
          .filter((c) => c.id != null)
          .map((c) => (
            <MenuItem key={c.id} value={c.id!}>
              {`${c.firstName} ${c.lastName} (${c.email})`}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
}
